import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TranslateService } from '@ngx-translate/core';
import { Events, LoadingController } from 'ionic-angular';
import { readAndCompressImage } from 'browser-image-resizer';

@Injectable()
export class Uploads {

    // Main task
    task: AngularFireUploadTask;
    loading: any;

    constructor(public storage: AngularFireStorage,
        public translate: TranslateService,
        public events: Events,
        public loadingCtrl: LoadingController) {
    }

    presentLoading() {
        this.loading = this.loadingCtrl.create({
            content: this.translate.instant('instant-subiendo-imagen')
        });
        this.loading.present();

    }
    presentLoadingExcel() {
        this.loading = this.loadingCtrl.create({
            content: this.translate.instant('general-subiendo-archivo')
        });
        this.loading.present();

    }


    upload(event: FileList, dir) {
        this.presentLoading();

        // The File object
        const file = event.item(0);
        // Client-side validation example
        if (file.type.split('/')[0] !== 'image') {
            return;
        }

        // The storage path
        var file_name = new Date().getTime() + '_' + file.name;
        const path = `${dir}/${file_name}`;
        // The main task
        this.storage.upload(path, file).then(data => {
            var file_name_completed = dir + '/' + file_name;
            this.events.publish('image:uploaded', file_name_completed);
            this.loading.dismiss();
        });
    }

    get(img) {
        var _img = this.storage.ref(img);
        _img.getDownloadURL().subscribe(actions => {
            this.events.publish('image:get', actions);
        });


    }

    async uploadComplete(event: FileList, dir) {//Upload image and retur image ref
        this.presentLoading();

        // The File object
        const file = event.item(0);
        // Client-side validation example
        if (file.type.split('/')[0] !== 'image') {
            return;
        }

        // The storage path
        var file_name = new Date().getTime() + '_' + file.name;
        const path = `${dir}/${file_name}`;
        var image_ref = dir + '/' + file_name;

        //compress
        if (dir === 'logo') {
            var config = {
                quality: 1,
                maxWidth: 360,
                maxHeight: 360
            };
            var fileResized = await readAndCompressImage(file, config);
            await this.storage.upload(path, fileResized); // upload image
        } else {
            await this.storage.upload(path, file); // upload image
        }

        this.loading.dismiss();
        return image_ref;

    }

    async uploadFilesComplete(fileList: File[], dir: string) {
        try {
            const file = fileList[0]; // Toma el primer archivo del arreglo (ya renombrado)

            const fileName = `${new Date().getTime()}_${file.name}`;
            const path = `${dir}/${fileName}`;
            const imageRef = `${dir}/${fileName}`;

            // Comprimir si es necesario
            const config = {
                quality: 1,
                maxWidth: 1280,
                maxHeight: 720,
            };
            const fileResized = await readAndCompressImage(file, config);
            await this.storage.upload(path, fileResized); // Subir imagen comprimida

            return imageRef;
        } catch (error) {
            return null;
        }
    }

    async uploadCompleteExcel(event: FileList, dir) {//Upload image and retur image ref
        this.presentLoadingExcel();

        // The File object
        const file = event.item(0);

        // The storage path
        var file_name = new Date().getTime() + '_' + file.name;
        const path = `${dir}/${file_name}`;
        var xls_ref = dir + '/' + file_name;

        await this.storage.upload(path, file) // upload image

        this.loading.dismiss();
        return xls_ref;

    }

    delete(img) {
        if (!img.includes('/predefinits/')) {
            var _img = this.storage.ref(img);
            _img.delete();
            // Eliminar también la imagen de la carpeta thumbnail si existe
            const thumbnailPath = img.replace(/^([^\/]+)\//, '$1/thumbnail/');
            var _thumbnail = this.storage.ref(thumbnailPath);
            _thumbnail.delete().subscribe({
                next: () => {},
                error: (error) => {}
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/services/uploads.ts